import { SafeDictionary } from "@insite/client-framework/Common/Types";
import { ApiParameter, post } from "@insite/client-framework/Services/ApiService";
import { ProductDto } from "@insite/client-framework/Types/ApiModels";

export interface CategoryIdParameter extends ApiParameter {
    categoryId?: string;
}

const supplyLandUrl = "/api/v1/supplyland";

export const invalidAddressException = "Insite.Core.Exceptions.InvalidAddressException";

export async function getProductsInParentCategory(parameter: CategoryIdParameter) {
    const testModel = await post<ProductDto[]>(
        `${supplyLandUrl}/getproductsinparentcategory?categoryId=${parameter.categoryId}`,
    );
    return testModel;
}

export async function getProductsInCategory(parameter: CategoryIdParameter) {
    const testModel = await post<ProductDto[]>(
        `${supplyLandUrl}/getproductsincategory?categoryId=${parameter.categoryId}`,
    );
    return testModel;
}

export async function getCategoryProductsDictionary(parameter: CategoryIdParameter) {
    const testModel = await post<SafeDictionary<readonly ProductDto[]>>(
        `${supplyLandUrl}/getdictionaryofcategoryproducts?categoryId=${parameter.categoryId}`,
    );
    return testModel;
}

export async function setLastPaymentMethodAsDefault() {
    const result = await post<boolean>(`${supplyLandUrl}/setLastPaymentMethodAsDefault`);
    return result;
}

export async function archiveShipTo(shipToId: string) {
    const result = await post<boolean>(`${supplyLandUrl}/archiveShipTo?shipToId=${shipToId}`);
    return result;
}
